import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/discover.vue
var o = {
	name: "DtIconDiscover",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--discover"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Discover",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("rect", {
			x: ".25",
			y: "3.75",
			width: "23.5",
			height: "16.5",
			rx: "1.75",
			fill: "#fff",
			stroke: "#E3E5E8",
			"stroke-width": ".5"
		}, null, -1),
		r("path", {
			d: "M4.482 19.947 23.5 14.18v4.32a1.465 1.465 0 0 1-1.465 1.447H4.482Z",
			fill: "#FD6020"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M21.23 10.402c.739 0 1.145.342 1.145.99.036.494-.296.913-.738.989l.996 1.408h-.775l-.849-1.37h-.073v1.37h-.628v-3.387h.923Zm-.294 1.56h.184c.406 0 .59-.19.59-.532 0-.305-.184-.495-.59-.495h-.184v1.027Zm-2.804 1.827h1.77v-.571H18.76v-.913h1.107v-.571H18.76v-.761h1.144v-.571h-1.771v3.387Zm-1.845-1.104-.848-2.283h-.664l1.365 3.463h.332l1.365-3.463h-.664l-.886 2.283Zm-7.489-.57c0 .95.738 1.75 1.66 1.75.295 0 .554-.076.812-.19v-.761c-.185.228-.443.38-.738.38-.59 0-1.07-.457-1.07-1.065v-.076a1.126 1.126 0 0 1 1.033-1.18c.295 0 .59.152.775.38v-.76c-.221-.153-.517-.191-.775-.191-.96-.076-1.697.723-1.697 1.712Zm-1.144-.419c-.369-.152-.48-.228-.48-.419.038-.228.222-.418.443-.38.185 0 .37.114.517.266l.332-.456c-.258-.229-.59-.381-.922-.381-.517-.038-.96.38-.996.913v.038c0 .457.184.724.774.914.148.038.295.114.443.19.11.076.184.19.184.343 0 .266-.22.494-.442.494H7.47a.729.729 0 0 1-.664-.456l-.406.418c.221.419.664.647 1.107.647.59.038 1.07-.418 1.107-1.027v-.115c-.037-.456-.222-.684-.96-.989Zm-2.14 2.093h.628v-3.387h-.627v3.387ZM2.6 10.402h1.107c.885.038 1.586.799 1.55 1.712 0 .495-.222.952-.591 1.294-.332.267-.738.419-1.144.38H2.6v-3.386Zm.812 2.816c.295.038.627-.076.848-.266.222-.228.332-.533.332-.875a1.2 1.2 0 0 0-.332-.838 1.144 1.144 0 0 0-.848-.266h-.185v2.245h.185Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M13.151 10.324c-.922 0-1.697.76-1.697 1.75 0 .952.738 1.75 1.697 1.789.96.038 1.697-.761 1.734-1.75-.037-.99-.774-1.79-1.734-1.79Z",
			fill: "#FD6020"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=discover.js.map